import { render } from "./CIS-ResourceDownloadFile.vue?vue&type=template&id=e9a32370&scoped=true"
import script from "./CIS-ResourceDownloadFile.vue?vue&type=script&lang=js"
export * from "./CIS-ResourceDownloadFile.vue?vue&type=script&lang=js"

import "./CIS-ResourceDownloadFile.vue?vue&type=style&index=0&id=e9a32370&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9a32370"]])

export default __exports__